export const MULTIPLIER = 1;
export const DIVIDER = 2;
